// extracted by mini-css-extract-plugin
module.exports = {"body":"qGp0zj06","fullscreenButtonContainer":"eujeytQ7","styledChartAreaWrapper":"zwRVLE3b","container":"jOtVmH1l","isChatMessage":"PDv1H9WW"};